import { useMutation, useQueryClient } from "react-query";
import { useSnackbar } from "notistack";

import { InvoiceCategory } from "../../models";
import { RQ } from "../../globals/enums";
import { remove } from "../../api/generic-api";
import { deleteEntity } from "../../utils";

export const useDeleteInvoiceCategory = () => {
  const queryClient = useQueryClient();
  const { enqueueSnackbar } = useSnackbar();

  return useMutation((id: string) => remove("invoice-categories", id), {
    onSuccess: (_, id) => {
      enqueueSnackbar("Invoice Category Deleted", { variant: "success" });
      queryClient.setQueryData(
        RQ.INVOICE_CATEGORIES,
        (invoiceCategories: InvoiceCategory[] | undefined) => {
          return !invoiceCategories
            ? []
            : deleteEntity<InvoiceCategory>(invoiceCategories, "id", id);
        }
      );
    },
    onError: () => {
      enqueueSnackbar("Invoice Category Deleting Error", { variant: "error" });
    },
  });
};
